import React from 'react';

/* 
  used in
  #1 /paybill ==> Pay page from menu ==> ==> top banner section
*/
function Banner({ height }) {
  return (
    <div className='sub_banner_comp'>
        <div className='shimmerBG shimmer-img-lg' style={{ height: height}}></div>
    </div>
  );
}

export default Banner;
